import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { spacing, sizing, colors, effects, transitions } from '@/styles/designTokens'

export const LayoutGrid = styled(Box)(({ theme }) => ({
	width: '100%',
	maxWidth: sizing.layoutMaxWidth,
	marginLeft: 'auto',
	marginRight: 'auto',
	display: 'grid',
	gridTemplateColumns: 'minmax(0, 1fr)',
	alignItems: 'start',
	[theme.breakpoints.up('lg')]: {
		gridTemplateColumns: `minmax(0, 1fr) ${sizing.cartSidebarWidth}px`,
		gap: spacing.xxxl,
		paddingLeft: spacing.xxxl,
		paddingRight: spacing.xxxl,
	},
	[theme.breakpoints.up('xl')]: {
		gridTemplateColumns: `minmax(0, 1fr) ${sizing.cartSidebarWidthWide}px`,
	},
}))

export const StickyHeader = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isCompact',
})<{ isCompact?: boolean }>(({ theme, isCompact }) => ({
	position: 'sticky',
	top: 0,
	zIndex: theme.zIndex.stickyHeader,
	width: '100%',
	backgroundColor: isCompact ? colors.surfaceMutedFrosted : colors.surfaceMuted,
	backdropFilter: isCompact ? effects.backdropBlur : 'none',
	WebkitBackdropFilter: isCompact ? effects.backdropBlur : 'none',
	transition: `background-color ${transitions.spatial}`,
}))

export const MainContent = styled('main')({})

export const CartSidebarSticky = styled(Box)(({ theme }) => ({
	display: 'none',
	[theme.breakpoints.up('lg')]: {
		display: 'flex',
		flexDirection: 'column',
		position: 'sticky',
		// Figma 562:39005: cart column wrapper has py-[24px] — cart sits 24px from viewport top.
		top: spacing.xl,
		// Constrain height so the items list can scroll internally.
		// svh excludes mobile browser chrome; subtract 24px top + 24px bottom padding.
		height: `calc(100svh - ${spacing.xl}px - ${spacing.xl}px)`,
	},
}))
